export enum JumioVerificationInitializationStatus {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}
